import { cva } from '@/styled-system/css';

export const loadingMaskContentRecipe = cva({
  variants: {
    loading: {
      true: {
        userSelect: 'none',
        _before: {
          base: {
            display: 'block',
            content: '""',
            position: 'absolute',
            zIndex: 'loadingMask',
            inset: 0,
            opacity: 'loadingMask',
          },
        },
      },
      false: {},
    },
    onImpact: {
      true: {},
      false: {},
    },
  },
  compoundVariants: [
    {
      loading: true,
      onImpact: false,
      css: {
        _before: {
          base: {
            background: 'bg.neutral',
          },
        },
      },
    },
    {
      loading: true,
      onImpact: true,
      css: {
        _before: {
          base: {
            background: 'bg.impact',
          },
        },
      },
    },
  ],
});
